/* eslint-disable no-console */

import { register } from 'register-service-worker'

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}service-worker.js`, {
    ready () {
      console.log(
          'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
      )
    },
    registered (registration) {
      console.log('Service worker has been registered.')
      setInterval(() => {
        registration.update()
      }, 5000)
    },
    cached (registration) {
      console.log('Content has been cached for offline use.', registration)
      document.dispatchEvent(
          new CustomEvent('swUpdated', { detail: registration })
      )
    },
    updatefound (registration) {
      console.log('New content is downloading...')
      document.dispatchEvent(
          new CustomEvent('swUpdated', { detail: registration })
      )
    },
    updated (registration) {
      console.log("Dispatch new update");
      if (registration.waiting) {
        // Optionally, send a message to the waiting service worker to skip waiting
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
    },
    offline () {
      console.log('No internet connection found! App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
